/**
 * استایل‌شیتِ توکن‌ها را یک‌بار به `<head>` اضافه می‌کند.
 *
 * نسخه‌ی کمینه‌ی apps/web/src/ui/theme.tsx: ادمین سوییچِ روشن/تیره ندارد و
 * همیشه تیره است. دلیلش سلیقه نیست — این صفحه پر از نمودار و جدولِ چگال است
 * و ساعت‌ها باز می‌ماند؛ زمینه‌ی تیره برای همین کار ساخته شده.
 *
 * چرا اصلاً لازم است: کلِ CSSِ این اپ `var(--…)` می‌خواند و آن متغیرها را
 * `themeCss()` می‌سازد. بدونِ این، صفحه بی‌رنگ بالا می‌آید.
 */
import React, { useEffect, useState } from 'react';
import { themeCss } from '@palsandplans/tokens';

const STYLE_ID = 'goout-tokens';

export function ThemeGate({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!document.getElementById(STYLE_ID)) {
      const el = document.createElement('style');
      el.id = STYLE_ID;
      el.textContent = themeCss();
      document.head.appendChild(el);
    }
    document.documentElement.setAttribute('data-theme', 'dark');
    setReady(true);
  }, []);

  // تا وقتی متغیرها توی head ننشسته‌اند چیزی نکشیم، وگرنه یک پرشِ بی‌رنگ
  // دیده می‌شود.
  return ready ? <>{children}</> : null;
}
